import { render, staticRenderFns } from "./releasePlanInfo.vue?vue&type=template&id=0c421788&scoped=true"
import script from "./releasePlanInfo.vue?vue&type=script&lang=js"
export * from "./releasePlanInfo.vue?vue&type=script&lang=js"
import style0 from "./releasePlanInfo.vue?vue&type=style&index=0&id=0c421788&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c421788",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c421788')) {
      api.createRecord('0c421788', component.options)
    } else {
      api.reload('0c421788', component.options)
    }
    module.hot.accept("./releasePlanInfo.vue?vue&type=template&id=0c421788&scoped=true", function () {
      api.rerender('0c421788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/releaseManage/releasePlanInfo.vue"
export default component.exports